import React from 'react';
import InputBase from '@material-ui/core/InputBase';
import { useChatContext } from 'features/message-center/providers';
import { formatInternationalPhone } from 'UI/utils';

import { SelectWithPadding, StyledMenuItem, StyledSelect } from './MultipleLineSelect.styled';

export const MultipleLineSelect = ({ enablePadding, onSelectLine }) => {
  const { internalNumber, userInternalPhones, handleSelectInternalNumber } = useChatContext();

  const hasMultipleLines = userInternalPhones.length > 1;

  const handleSelectPhone = phone => {
    handleSelectInternalNumber(phone);
    onSelectLine && onSelectLine();
  };

  const SelectComponent = enablePadding ? SelectWithPadding : StyledSelect;

  return hasMultipleLines ? (
    <SelectComponent
      displayEmpty
      input={<InputBase />}
      onChange={event => handleSelectPhone(event.target.value)}
      renderValue={selected => `From: ${formatInternationalPhone(selected)}`}
      value={internalNumber}
    >
      {userInternalPhones.map(({ phoneNumber }) => (
        <StyledMenuItem key={phoneNumber} value={phoneNumber}>
          {formatInternationalPhone(phoneNumber)}
        </StyledMenuItem>
      ))}
    </SelectComponent>
  ) : null;
};
